export function useQueryparam(): URLSearchParams {
    return new URLSearchParams(window.location.search);
}
